



























import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import utils from '@/services/utils';

@Component
export default class CrytoAccountBody extends Vue {
  @Prop() readonly data: any;

  @Prop() readonly openModal!: Function;

  @Prop() readonly remove!: Function;

  utilsInstance = utils;
}
